import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import { ITrainingCentreData } from 'partner360/models/trainingCentre/ITrainingCentre'

export const fetchTrainingCentreData = async (): Promise<ITrainingCentreData | null> => {
  const url = proxy('/webservice/621/sp/v3/spJBPTrainingCenter/call')
  const [accessToken] = getTokens()

  const headers = new HttpHeaders()

  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  const response = await Rest.post({ url, headers })

  const res = response.Rows[0]?.Result

  if (!res) {
    return null
  }

  const parsedData: ITrainingCentreData = JSON.parse(res)

  return {
    Rtms: [...parsedData.Rtms].sort((a, b) => a.Order - b.Order),
    Topics: [...parsedData.Topics].sort((a, b) => a.Order - b.Order),
    Sections: [...parsedData.Sections].sort((a, b) => a.Order - b.Order),
  }
}
